import React from 'react';
import '../css/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {currentYear} AI City. All rights reserved.</p>
      </div>
      <div className="footer-details">
        <div className="footer-row">
          <p>☎️: 02 5500 9628</p>
          <p>🏢: Level 1, 63-73 Ann Street, Surry Hills, NSW 2010</p>
          <p>📧: info@aicity.com.au</p>
          <p>🈺: ABN 26682330507 / ACN: 682330507</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
